class SupplabShippingStrip extends HTMLElement {
  connectedCallback() {
    document.addEventListener('cart:update', this.onCartUpdate);
    document.addEventListener('discount:update', this.queueRefresh);
    window.addEventListener('pageshow', this.onPageShow);
    this.syncHeaderOffset();
  }
  // El mega menú abre debajo de esta franja: publica su altura real en el header (ver cart-rewards-bar.css).
  syncHeaderOffset() {
    const header = this.closest('#header-component');
    if (!header) return;
    const apply = () => header.style.setProperty('--supplab-strip-height', this.offsetHeight + 'px');
    apply();
    if (typeof ResizeObserver === 'undefined') return;
    this.resizeObserver = new ResizeObserver(apply);
    this.resizeObserver.observe(this);
  }
  disconnectedCallback() {
    this.resizeObserver?.disconnect();
    document.removeEventListener('cart:update', this.onCartUpdate);
    document.removeEventListener('discount:update', this.queueRefresh);
    window.removeEventListener('pageshow', this.onPageShow);
    clearTimeout(this.timer);
    this.controller?.abort();
  }
  // The initial HTML already contains current cart totals. Refresh only on Back/Forward cache restore.
  onPageShow = (event) => { if (event.persisted) this.queueRefresh(); };
  onCartUpdate = (event) => {
    const cart = event.detail?.resource;
    if (Number.isFinite(cart?.total_price) && Number.isFinite(cart?.item_count) && Array.isArray(cart?.items)) {
      clearTimeout(this.timer);
      this.controller?.abort();
      this.renderCart(cart);
    } else this.queueRefresh();
  };
  queueRefresh = () => {
    clearTimeout(this.timer);
    this.timer = setTimeout(() => this.refresh(), 80);
  };
  async refresh() {
    this.controller?.abort();
    const controller = new AbortController();
    this.controller = controller;
    try {
      const response = await fetch(this.dataset.cartUrl + '.js', {signal:controller.signal, cache:'no-store'});
      if (!response.ok) return;
      const cart = await response.json();
      if (this.isConnected && !controller.signal.aborted) this.renderCart(cart);
    } catch (error) {
      if (error.name !== 'AbortError') console.warn('No se pudo actualizar el progreso de envío.');
    }
  }
  renderCart(cart) {
    const goal = Number(this.dataset.goal);
    const message = this.querySelector('[data-message]');
    const progress = this.querySelector('[data-progress]');
    if (!message || !progress || !(goal > 0)) return;
    const remaining = Math.max(0, goal - cart.total_price);
    // Envío gratis solo con 2 o más productos; cada paquete ya cuenta como varios.
    const bundles = (cart.items || []).filter((item) => item.product_type === 'Paquete').length;
    const needsMoreItems = cart.item_count > 0 && remaining === 0 && cart.item_count + bundles < 2;
    const money = new Intl.NumberFormat('es-MX', {style:'currency', currency:cart.currency || this.dataset.currency, minimumFractionDigits:2, maximumFractionDigits:2}).format((cart.item_count ? remaining : goal) / 100);
    const emphasis = document.createElement('strong');
    emphasis.textContent = needsMoreItems ? '1 producto más' : remaining === 0 ? 'envío gratis' : money;
    if (needsMoreItems) message.replaceChildren('Agrega ', emphasis, ' y tu envío es gratis');
    else if (remaining === 0) message.replaceChildren('¡Tu pedido ya tiene ', emphasis, '!');
    else if (cart.item_count) message.replaceChildren('Te faltan ', emphasis, ' para envío gratis');
    else message.replaceChildren('Envío gratis desde ', emphasis, ' en 2+ productos');
    progress.style.width = (needsMoreItems ? 90 : Math.min(100, Math.max(0, cart.total_price / goal * 100))) + '%';
  }
}
if (!customElements.get('supplab-shipping-strip')) customElements.define('supplab-shipping-strip', SupplabShippingStrip);
